import {
  mergeModules,
  makeVuexProp,
  makeVuexList,
  vuexListTestCallbacks,
} from '../../utils/vuexUtils';

let moduleName = 'app';

let { module: languages, storeTypes: languagesStoreTypes } = makeVuexList({
  namespace: moduleName,
  listName: 'languages',
  key: 'Id',
});
let { module: countries, storeTypes: countriesStoreTypes } = makeVuexList({
  namespace: moduleName,
  listName: 'countries',
  key: 'Id',
});
let {
  module: selectedCountry,
  storeTypes: selectedCountryStoreTypes,
} = makeVuexProp({
  namespace: moduleName,
  propName: 'selectedCountry',
  value: { ResourceKey: 'country_Hungary' },
});

let AppStoreTypes = {
  languages: languagesStoreTypes,
  countries: countriesStoreTypes,
  selectedCountry: selectedCountryStoreTypes,
};

let app = mergeModules([languages, countries, selectedCountry]);

export { app, AppStoreTypes };
